export default __webpack_public_path__ + "static/subclass-solar-5f94c0.png";